import { Dispatch, useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Action } from 'redux';

import lang from '../../../../../../lib/language';
import { RootState } from '../../../../../../lib/store';
import { sendResetPassword } from '../../../../../../lib/store/auth';

import BaseModal from '../../../../../../shared_components/BaseModal/BaseModal';
import Button from '../../../../../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../../../../../shared_components/Button/Button.types';

import styles from './ModalChangePassword.module.scss';

type OwnProps = {
  isOpen: boolean;
  onClose: () => void;
};

type Props = OwnProps & ReduxProps;

const ModalChangePassword = (props: Props) => {
  const {
    isOpen,
    onClose,
    resetPassword,
    individual,
  } = props;

  const [infoModal, setInfoModal] = useState<{ title: string, isProceed: boolean }>(
    {
      title: lang.mobileChangePasswordModalText(),
      isProceed: false,
    },
  );

  // The modal lives outside the dropdown so it survives the dropdown unmounting, which means
  // it is never remounted — reset it back to the first step on every open.
  useEffect(() => {
    if (isOpen) {
      setInfoModal({ title: lang.mobileChangePasswordModalText(), isProceed: false });
    }
  }, [isOpen]);

  const handleProceed = () => {
    if (infoModal.isProceed) {
      onClose();
    } else {
      resetPassword();
      setInfoModal({ ...infoModal, title: lang.mobilePasswordChangeEmailTitle(), isProceed: true });
    }
  };

  return (
    <BaseModal isOpen={isOpen} toggle={onClose}>
      <div className={styles.title}>{infoModal.title}</div>
      {infoModal.isProceed && (
        <span className={styles.messageSentEmail}>
          {
            `${lang.mobilePasswordChangeEmailUnderlineHeading1()}
            ${individual?.email ?? ''}
            ${lang.mobilePasswordChangeEmailUnderlineHeading2()}`
          }
        </span>
      )}
      <div className={styles.buttonsWrapper}>
        <Button
          key={infoModal.isProceed ? 'okay-button' : 'proceed-button'}
          fullWidth
          biggerFontSize
          onClick={handleProceed}
        >
          {infoModal.isProceed ? lang.commonOkay() : lang.commonOrderSideButtonProceed()}
        </Button>
        {!infoModal.isProceed && (
          <Button
            variant={ButtonTypesEnum.Secondary}
            fullWidth
            biggerFontSize
            onClick={onClose}
          >
            {lang.commonCancelButton()}
          </Button>
        )}
      </div>
    </BaseModal>
  );
};

const mapStateToProps = (state: RootState) => ({
  individual: state.crm.individualExtendedInfo,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  resetPassword: () => dispatch(sendResetPassword({})),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ModalChangePassword);
